function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//@ts-nocheck
import React from "react";
import { Grid, Button, Typography, Card, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, CircularProgress, IconButton, Drawer, Divider, TextField, Backdrop, Menu, MenuItem, Dialog, DialogContent } from "@material-ui/core";
import { default as ReactSelect } from "react-select";
import { components } from "react-select";
import { withStyles } from "@material-ui/styles";
import ReactTooltip from "react-tooltip";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import UserProfileBasicBlockController from "./UserProfileBasicController";
import "./UserManagement.web.css";
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  },
  getContentAnchorEl: null,
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "center"
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "center"
  },
  variant: "menu"
};
const Option = props => {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(components.Option, props, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    checked: props.isSelected,
    onChange: () => null
  }), " ", /*#__PURE__*/React.createElement("label", null, props.label)));
};
const customStyles = {
  multiValueLabel: base => _objectSpread(_objectSpread({}, base), {}, {
    fontFamily: "Poppins"
  }),
  menuList: base => _objectSpread(_objectSpread({}, base), {}, {
    fontFamily: "Poppins"
  })
};
const customStylesWithError = {
  multiValueLabel: base => _objectSpread(_objectSpread({}, base), {}, {
    fontFamily: "Poppins"
  }),
  menuList: base => _objectSpread(_objectSpread({}, base), {}, {
    fontFamily: "Poppins"
  }),
  control: base => _objectSpread(_objectSpread({}, base), {}, {
    boxShadow: "none",
    borderColor: "red",
    "&:hover": {
      borderColor: "red"
    }
    // You can also use state.isFocused to conditionally style based on the focus state
  })
};
const actionDots = require("../assets/3dots.png");
const trashIcon = require("../assets/trash.png");
const editIcon = require("../assets/edit.png");
export class UserManagement extends UserProfileBasicBlockController {
  constructor(props) {
    super(props);
    //Customizable Area Start
    //Customizable Area End
  }
  render() {
    const {
      navigation,
      classes
    } = this.props;
    //Customizable Area Start
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Backdrop, {
      className: classes.backdrop,
      open: this.state.loading
    }, /*#__PURE__*/React.createElement(CircularProgress, {
      color: "inherit"
    })), /*#__PURE__*/React.createElement(ToastContainer, null), /*#__PURE__*/React.createElement(Card, {
      className: classes.mainCard
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 2,
      style: {
        padding: "20px"
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 10
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      className: classes.text1
    }, "User Management")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 2
    }, /*#__PURE__*/React.createElement(Button, {
      "data-test-id": "createUser",
      variant: "contained",
      className: classes.exportBtn,
      onClick: this.handleDrawer,
      disabled: !this.state.canCreateUser
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      className: classes.text3
    }, "Create User"))))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(TableContainer, null, /*#__PURE__*/React.createElement(Table, {
      className: classes.table,
      "aria-label": "simple table"
    }, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      className: classes.tableHeads
    }, "User Name")), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      className: classes.tableHeads
    }, "Email ID")), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      className: classes.tableHeads
    }, "Contact")), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      className: classes.tableHeads
    }, "Role")), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      className: classes.tableHeads
    }, "IMEI")), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      className: classes.tableHeads
    }, "Device ID")), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      className: classes.tableHeads
    }, "Action")))), /*#__PURE__*/React.createElement(TableBody, null, this.state.userData.length !== 0 ? this.state.userData.map((_data, index) => /*#__PURE__*/React.createElement(React.Fragment, {
      key: index
    }, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
      className: classes.tableDatas
    }, _data.userName), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.tableDatas
    }, _data.email), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.tableDatas
    }, "+".concat(_data.contact)), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.tableDatas
    }, _data.role), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.tableDatas
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        paddingLeft: "5px"
      }
    },
    // _data.devices? 
    _data.devices.length !== 0 ? "".concat(_data.devices[0].attributes.imei_number) : "NA"
    // : "NA"
    ), /*#__PURE__*/React.createElement("div", {
      "data-test-id": "currentTarget",
      onClick: event => {
        this.setState({
          anchorEl: event.currentTarget
        });
      },
      style: {
        display: "inline",
        paddingLeft: "10px",
        cursor: "pointer"
      }
    }, /*#__PURE__*/React.createElement("a", {
      "data-tip": true,
      "data-for": "imei"
    }, _data.devices ? _data.devices.length !== 0 ? "+".concat(_data.devices.length - 1) : "" : "")), /*#__PURE__*/React.createElement(ReactTooltip, {
      id: "imei",
      "aria-haspopup": "true",
      className: "custom-color",
      backgroundColor: "#FFFFFF",
      effect: "solid"
    }, _data.devices.length !== 0 ? _data.devices.map((_devices, idx) => {
      if (idx !== 0) {
        return /*#__PURE__*/React.createElement(Grid, {
          container: true,
          key: idx
        }, /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12,
          style: {
            justifyContent: "center",
            display: "flex",
            textAlign: "center"
          }
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "body2",
          className: classes.text6
        }, _devices.attributes.imei_number)));
      }
    }) : null)), /*#__PURE__*/React.createElement(TableCell, {
      align: "justify",
      className: classes.tableDatas
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        paddingLeft: "5px"
      }
    }, _data.devices ? _data.devices.length !== 0 ? "".concat(_data.devices[0].attributes.sid) : "" : ""), /*#__PURE__*/React.createElement("div", {
      id: "handleDeviceMoreClickBtn",
      onClick: event => {
        this.handleDeviceMoreClick(event, _data.devices);
      },
      style: {
        display: "inline",
        paddingLeft: "10px",
        cursor: "pointer"
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: classes.text7
    }, /*#__PURE__*/React.createElement("a", {
      "data-tip": true,
      "data-for": "deviceid"
    }, _data.devices ? _data.devices.length !== 0 ? "+".concat(_data.devices.length - 1) : "NA" : "NA"))), /*#__PURE__*/React.createElement(ReactTooltip, {
      id: "deviceid",
      "aria-haspopup": "true",
      className: "custom-color",
      backgroundColor: "#FFFFFF",
      effect: "solid"
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true
    }, _data.devices.length !== 0 ? _data.devices.map((_devices, idx) => {
      if (idx !== 0) {
        return /*#__PURE__*/React.createElement(Grid, {
          key: idx,
          item: true,
          xs: 12,
          style: {
            justifyContent: "center",
            display: "flex",
            textAlign: "center"
          }
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "body2",
          className: classes.text6
        }, _devices.attributes.sid));
      }
    }) : null))), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(IconButton, {
      id: "handleOpenMenu",
      onClick: e => {
        this.handleOpenAboutMenu(e, _data);
      }
    }, /*#__PURE__*/React.createElement("img", {
      src: actionDots
      // onClick={(e) => {
      //   this.handleOpenAboutMenu(e, _data);
      // }}
    })))))) : "", /*#__PURE__*/React.createElement(Menu, {
      id: "simple-menu",
      anchorEl: this.state.anchorEl3,
      keepMounted: true,
      open: Boolean(this.state.anchorEl3),
      style: {
        marginTop: "40px"
      },
      onClose: this.handleAboutMenuClose
    }, /*#__PURE__*/React.createElement(MenuItem, {
      id: "userEdit",
      onClick: this.handleUserEdit
    }, "Edit"), /*#__PURE__*/React.createElement(MenuItem, {
      id: "userDelete",
      onClick: this.handleUserDelete
    }, "Delete")))))))), /*#__PURE__*/React.createElement(Drawer, {
      anchor: "right",
      open: this.state.drawer,
      onClose: this.handleDrawer
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 2,
      style: {
        width: "300px"
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      style: {
        padding: "20px"
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 9
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      className: classes.text1
    }, "Create User")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 1
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      className: classes.btnUserCancel,
      onClick: this.handleDrawer
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        color: "#FFFFFF"
      }
    }, "x"))))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(Divider, null)), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 2,
      style: {
        padding: "20px"
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      className: classes.text4
    }, "First Name")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(TextField, {
      id: "txtFirstName",
      fullWidth: true,
      variant: "outlined",
      value: this.state.firstName,
      onChange: this.handleFirstName,
      error: !this.state.isFirstNameValid ? true : false,
      helperText: /*#__PURE__*/React.createElement("span", {
        style: {
          fontSize: "12px",
          fontFamily: "Poppins"
        }
      }, this.state.firstNameErrorMessage)
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      className: classes.text4
    }, "Last Name")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(TextField, {
      fullWidth: true,
      variant: "outlined",
      value: this.state.lastName,
      onChange: this.handleLastName,
      error: !this.state.isLastNameValid ? true : false,
      helperText: /*#__PURE__*/React.createElement("span", {
        style: {
          fontSize: "12px",
          fontFamily: "Poppins"
        }
      }, this.state.lastNameErrorMessage)
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      className: classes.text4
    }, "Email ID")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(TextField, {
      fullWidth: true,
      variant: "outlined",
      value: this.state.emailId,
      onChange: this.handleEmail,
      error: !this.state.isEmailValid ? true : false,
      helperText: /*#__PURE__*/React.createElement("span", {
        style: {
          fontSize: "12px",
          fontFamily: "Poppins"
        }
      }, this.state.emailErrorMessage)
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      className: classes.text4
    }, "Contact")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(TextField, {
      fullWidth: true,
      variant: "outlined",
      value: this.state.contact,
      onChange: this.handleContact
      // InputProps={{
      //   startAdornment: (
      //     <InputAdornment position="start">+91</InputAdornment>
      //   ),
      // }}
      ,
      error: !this.state.isContactValid ? true : false,
      helperText: /*#__PURE__*/React.createElement("span", {
        style: {
          fontSize: "12px",
          fontFamily: "Poppins"
        }
      }, this.state.contactErrorMessage)
    }), /*#__PURE__*/React.createElement("small", {
      className: classes.text4
    }, "Enter phone number with country code (Ex. 91XXXXXXXXXX)")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      className: classes.text4
    }, "Devices")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(ReactSelect, {
      id: "devices",
      options: this.state.deviceList,
      hideSelectedOptions: false,
      onChange: this.handleDeviceChange,
      value: this.state.selectedDevice,
      styles: customStyles,
      placeholder: /*#__PURE__*/React.createElement("span", {
        className: classes.text2
      }, "Select Devices")
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      className: classes.text4
    }, "Sub Devices")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(ReactSelect, {
      options: this.state.subDeviceList,
      isMulti: true,
      closeMenuOnSelect: false,
      hideSelectedOptions: false,
      components: {
        Option
      },
      onChange: this.handleSubDeviceChange,
      allowSelectAll: true,
      value: this.state.selectedSubDevice,
      styles: this.state.isDeviceValid ? customStyles : customStylesWithError,
      placeholder: /*#__PURE__*/React.createElement("span", {
        className: classes.text2
      }, "Select Sub Device")
    }), !this.state.isDeviceValid ? /*#__PURE__*/React.createElement("span", {
      style: {
        fontSize: "12px",
        fontFamily: "Poppins",
        color: "red",
        paddingLeft: "15px"
      }
    }, this.state.deviceErrorMessage) : ""), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(Button, {
      id: "btnCheckFormDetails",
      variant: "outlined",
      className: classes.DrawerBtnCreateUser,
      fullWidth: true,
      onClick: this.checkFormDetails
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      className: classes.text5
    }, this.state.isEdit ? "Update User" : "Create User"))))))), /*#__PURE__*/React.createElement(Dialog, {
      open: this.state.deleteDialogFlag,
      onClose: this.handleCloseDeleteDialog,
      "aria-labelledby": "alert-dialog-title",
      "aria-describedby": "alert-dialog-description"
    }, /*#__PURE__*/React.createElement(DialogContent, {
      style: {
        width: "400px",
        height: "300px"
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "column",
      alignItems: "center",
      justify: "center"
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      style: {
        minHeight: "120px"
      }
    }, /*#__PURE__*/React.createElement("img", {
      src: trashIcon,
      alt: "trash",
      style: {
        paddingTop: "25px"
      }
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      className: classes.text8
    }, "Are you sure?")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      style: {
        textAlign: "center",
        paddingTop: "10px"
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      className: classes.text11
    }, "This action cannot be undone once it is performed"))), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      alignItems: "center",
      style: {
        paddingLeft: "10px",
        paddingTop: "20px"
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 2
    }), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 4
    }, /*#__PURE__*/React.createElement(Button, {
      id: "closeDeleteDialog",
      variant: "contained",
      className: classes.deleteCancelBtn,
      onClick: this.handleCloseDeleteDialog
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      className: classes.text9
    }, "Cancel"))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 4
    }, /*#__PURE__*/React.createElement(Button, {
      id: "deleteUser",
      variant: "contained",
      onClick: this.deleteUser,
      className: classes.deleteDeleteBtn
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      className: classes.text10
    }, "Delete"))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 2
    })))), /*#__PURE__*/React.createElement(Dialog, {
      open: this.state.editDialogFlag,
      onClose: this.handleCloseEditDialog,
      "aria-labelledby": "alert-dialog-title",
      "aria-describedby": "alert-dialog-description"
    }, /*#__PURE__*/React.createElement(DialogContent, {
      style: {
        width: "400px",
        height: "300px"
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "column",
      alignItems: "center",
      justify: "center"
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      style: {
        minHeight: "120px"
      }
    }, /*#__PURE__*/React.createElement("img", {
      src: editIcon,
      alt: "trash",
      style: {
        paddingTop: "25px"
      }
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      className: classes.text8
    }, "Are you sure?")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      style: {
        textAlign: "center",
        paddingTop: "10px"
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      className: classes.text11
    }, "This will edit your existing data"))), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      alignItems: "center",
      style: {
        paddingLeft: "10px",
        paddingTop: "20px"
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 2
    }), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 4
    }, /*#__PURE__*/React.createElement(Button, {
      id: "closeEditDialog",
      variant: "contained",
      className: classes.deleteCancelBtn,
      onClick: this.handleCloseEditDialog
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      className: classes.text9
    }, "Cancel"))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 4
    }, /*#__PURE__*/React.createElement(Button, {
      id: "confirmEditUser",
      variant: "contained",
      className: classes.editConfirmBtn,
      onClick: this.confirmEditUser
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      className: classes.text10
    }, "Confirm"))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 2
    })))));
    //Customizable Area End
  }
}

// Customizable Area Start
const styles = theme => ({
  // mainCard: {
  //   boxShadow: "10px 15px 15px #eaeaea, -10px -9px 15px #eaeaea",
  // },
  text1: {
    opacity: 1,
    fontWeight: 500,
    color: "rgba(17, 20, 45, 1)",
    fontFamily: "Poppins",
    fontSize: "25px"
  },
  text2: {
    opacity: 1,
    fontStyle: "normal",
    fontWeight: 500,
    color: "rgba(128, 129, 145, 1)",
    fontFamily: "Poppins",
    fontSize: "13px"
  },
  text3: {
    opacity: 1,
    fontWeight: 500,
    color: "rgba(255, 255, 255, 1)",
    fontFamily: "Poppins",
    fontSize: "14px"
  },
  exportBtn: {
    backgroundColor: "#79A1FA",
    width: "160px",
    height: "58px"
  },
  tableHeads: {
    opacity: 1,
    fontWeight: 500,
    color: "rgba(178, 179, 189, 1)",
    fontFamily: "Poppins",
    fontSize: "12px"
  },
  bottom: {
    color: "#79A1FA"
  },
  tableDatas: {
    opacity: 1,
    fontWeight: 500,
    color: "rgba(17, 20, 45, 1)",
    fontFamily: "Poppins",
    fontSize: "14px"
  },
  loadMoreBtnTxt: {
    opacity: 1,
    fontWeight: 800,
    color: "rgba(255, 255, 255, 1)",
    fontFamily: "Poppins",
    fontSize: "14px"
  },
  loadMoreBtn: {
    width: "166px",
    height: "56px",
    backgroundColor: "#141618",
    borderRadius: "15px"
  },
  btnUserCancel: {
    backgroundColor: "#79A1FA",
    minWidth: "0px",
    borderRadius: "20px"
  },
  text4: {
    opacity: 1,
    fontWeight: 500,
    color: "rgba(178, 179, 189, 1)",
    fontFamily: "Poppins",
    fontSize: "12px"
  },
  DrawerBtnCreateUser: {
    backgroundColor: "#79A1FA",
    height: "50px"
  },
  text5: {
    opacity: 1,
    fontWeight: 500,
    color: "#FFFFFF",
    fontFamily: "Poppins",
    fontSize: "15px"
  },
  backdrop: {
    zIndex: 9999,
    color: "#fff"
  },
  text6: {
    opacity: 1,
    fontWeight: 500,
    color: "rgba(17, 20, 45, 1)",
    fontFamily: "Poppins",
    fontSize: "15px"
  },
  text7: {
    paddingLeft: "5px",
    textDecoration: "underline",
    color: "#91B2FD",
    fontFamily: "Poppins",
    fontSize: "14px",
    fontWeight: 500
  },
  menuGridRoot: {
    width: "auto",
    height: "auto",
    maxWidth: "200px"
  },
  formControl: {
    width: "100%"
  },
  text8: {
    fontFamily: "Poppins",
    fontSize: "25px",
    fontWeight: 800,
    color: "rgba(17, 20, 45, 1)"
  },
  deleteCancelBtn: {
    backgroundColor: "#909090",
    width: "100px",
    height: "25px"
  },
  deleteDeleteBtn: {
    backgroundColor: "#F54E4F",
    width: "100px",
    height: "25px"
  },
  text9: {
    fontFamily: "Poppins",
    color: "#FFFFFF",
    fontSize: "13px",
    fontWeight: 600
  },
  text10: {
    fontFamily: "Poppins",
    fontSize: "13px",
    color: "#FFFFFF",
    fontWeight: 600
  },
  text11: {
    fontFamily: "Poppins",
    fontSize: "14px",
    color: "#909090",
    fontWeight: 700
  },
  editConfirmBtn: {
    backgroundColor: "#79A1FA",
    width: "100px",
    height: "25px"
  }
});

// Customizable Area End

export default withStyles(styles(), {
  withTheme: true
})(UserManagement);